/**
 * ThinClient WebSocket and detection configuration.
 * Single place for URL, timeouts, and protocol constants used by ThinClientDetector
 * and WebSocketThinClientInterface.
 */

export const WS_URL = 'ws://localhost:9001';

export const INITIAL_TIMEOUT_MS = 500;
export const RETRY_TIMEOUT_MS = 1000;
export const RETRY_INTERVAL_MS = 10000;
export const MAX_RETRIES = -1;

export const REQUEST_TIMEOUT_MS = 10000;
export const HEARTBEAT_INTERVAL_MS = 10000;
export const RECONNECT_BASE_DELAY_MS = 1000;
export const RECONNECT_MAX_DELAY_MS = 30000;
export const CONNECTION_CHECK_INTERVAL_MS = 5000;
export const CONNECTION_TIMEOUT_MS = 5000;

export const REQUEST_ID_RANDOM_LENGTH = 9;
export const ERROR_WEIGHT_VALUE = -1;
export const WS_SUCCESS_ERROR_CODE = 0;
